import { render, staticRenderFns } from "./JobsiteInsuranceList.vue?vue&type=template&id=864ed952"
import script from "./JobsiteInsuranceList.vue?vue&type=script&lang=js"
export * from "./JobsiteInsuranceList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports